import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  height: 250px;
  display: flex;
  flex-direction: column;

  .trends-header {
    
    .trends-title {
      font-size: 18px;
      font-weight: 600;
      color: #383e48;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 4px;
      padding-left: 4px;
    }

    .trends-summary {
      font-size: 14px;
      color: #6d7d8c;
      line-height: 1.5;
      margin-bottom: 16px;
    }
  }

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 60px 0;
  }

  .empty-container {
    padding: 40px 0;
    text-align: center;
  }

  .trends-content {
    background: white;
    border-radius: 6px;
    padding: 16px;
    overflow-x: auto;
    overflow-y: auto;
    flex: 1;
    min-height: 0;
    
    .metrics-list {
      list-style: disc;
      padding-left: 14px;
      
      li {
        margin-bottom: 8px;
        color: #383e48;
        font-size: 14px;
        
        .metric-name {
          font-weight: 500;
        }
        
        .metric-change {
          margin-left: 8px;
          font-size: 13px;
          
          &.positive {
            color: #7BAD2D;
          }
          
          &.negative {
            color: #CF072A;
          }
        }
      }
    }
    
    /* Custom scrollbar styling */
    &::-webkit-scrollbar {
      height: 6px;
      width: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #cbd2d9;
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
      background: #9aa5b1;
    }
  }
`

const ClientTrendsSummary = ({ person, metricGroup, loading }) => {
  const getSignificantMetrics = () => {
    if (!metricGroup || metricGroup.length === 0) {
      return []
    }

    // Get all significant metrics from all metric groups
    const allSignificantMetrics = metricGroup.flatMap(group => 
      group.display_metrics.filter(metric => 
        metric.detail && Math.abs(metric.detail.overall_ratio) >= 20
      )
    )

    return allSignificantMetrics.slice(0, 5)
  }

  const significantMetrics = getSignificantMetrics()

  return (
    <Container>
      <div className="trends-header">
        <div className="trends-title">
          <span>Trends Summary</span>
        </div>
      </div>
      <div className="trends-content">
        {loading ? (
          <div className="loading-container">
            <div className="ant-spin-container">
              <div className="ant-spin ant-spin-spinning">
                <span className="ant-spin-dot">
                  <i></i>
                  <i></i>
                </span>
              </div>
            </div>
          </div>
        ) : significantMetrics.length > 0 ? (
          <ul className="metrics-list">
            {significantMetrics.map((metric, index) => (
              <li key={index}>
                <span className="metric-name">{metric.name}</span>
                <span className={`metric-change ${metric.detail.overall_ratio > 0 ? 'positive' : 'negative'}`}>
                  ({metric.detail.overall_ratio > 0 ? '+' : ''}{metric.detail.overall_ratio.toFixed(1)}%)
                </span>
              </li>
            ))}
          </ul>
        ) : (
          <div className="empty-container">
            No significant trends were detected over the last 90 days.
          </div>
        )}
      </div>
    </Container>
  )
}

export default ClientTrendsSummary
